import _ from 'underscore';
import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  useImageExperienceAdPreviewModel,
  AdPreviewCarouselLayout,
  UAPPlacementTypeAlias as EPT,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';

import { getOnRenderPlacement } from './unified-placement-render';
import { ImageExperienceImage } from '../model/image-experience-image';

const adPreviewConfig = [{
  placementSetName: 'Carousel178x100',
  placementTypes: [
    EPT.ImageExt.BingDesktopSingleImage,
    EPT.ImageExt.MSEdgeSingleCarousel,
  ],
}];

export const UnifiedCarouselPreview178x100 = ({
  image, previewTexts, i18n, classes,
}) => {
  const {
    multiImagePlacementSets: placementSets,
    onUpdateImageExperienceImageList,
  } = useImageExperienceAdPreviewModel(adPreviewConfig);

  const placementList = useMemo(() => {
    // should only have one placement set
    const list = _.chain(placementSets).map(placementSet => placementSet.placementList).flatten().value();
    return list;
  }, [placementSets]);

  useEffect(() => {
    onUpdateImageExperienceImageList([[image]]);
  }, [image, onUpdateImageExperienceImageList]);

  const onRenderPlacement = useMemo(() => {
    const params = {
      isMultimediaAd: false,
      isMultiMediaAdsPhase2Enabled: false,
      previewTexts,
      i18n,
    };
    return getOnRenderPlacement(params, classes.previewPlacementContainerRoot);
  }, [classes.previewPlacementContainerRoot, i18n, previewTexts]);

  return (
    <AdPreviewCarouselLayout
      placementList={placementList}
      onRenderPlacement={onRenderPlacement}
      enableAutoRotate={false}
      i18n={i18n}
      disableDefaultStyles
      customCarouselLayoutStyles="edit-carousel-container"
    />
  );
};

UnifiedCarouselPreview178x100.propTypes = {
  previewTexts: PropTypes.shape({
    longHeadline: PropTypes.string,
    description: PropTypes.string,
    businessName: PropTypes.string,
  }).isRequired,
  image: PropTypes.instanceOf(ImageExperienceImage).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
};
